import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Header } from "@/components/site/Header";
import { HeroChicago } from "@/components/site/HeroChicago";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { ValueProps } from "@/components/site/ValueProps";
import { Footer } from "@/components/site/Footer";
import { WhyChooseChicago } from "@/components/site/WhyChooseChicago";
import img__asset from "@/assets/restore/locations/philadelphia.jpg.asset.json";

const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));
const Reviews = lazy(() => import("@/components/site/Reviews").then(m => ({ default: m.Reviews })));
const NoShaveFuture = lazy(() => import("@/components/site/NoShaveFuture").then(m => ({ default: m.NoShaveFuture })));
const NoShaveWhy = lazy(() => import("@/components/site/NoShaveWhy").then(m => ({ default: m.NoShaveWhy })));
const Guarantee = lazy(() => import("@/components/site/Guarantee").then(m => ({ default: m.Guarantee })));
const Pricing = lazy(() => import("@/components/site/Pricing").then(m => ({ default: m.Pricing })));
const Surgeons = lazy(() => import("@/components/site/Surgeons").then(m => ({ default: m.Surgeons })));
const DoctorsGrid = lazy(() => import("@/components/site/DoctorsGrid").then(m => ({ default: m.DoctorsGrid })));
const LocationsMapGeneric = lazy(() => import("@/components/site/LocationsMapGeneric").then(m => ({ default: m.LocationsMapGeneric })));
const VirtualConsult = lazy(() => import("@/components/site/VirtualConsult").then(m => ({ default: m.VirtualConsult })));
const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/locations/pennsylvania/philadelphia")({
  head: () => ({
    meta: [
      { title: "Get Your Hair Back | RESTORE® Hair Transplants — Philadelphia" },
      { name: "description", content: "Find out about your hair transplant options in Philadelphia with RESTORE® Hair. Over 20,000 procedures performed." },
      { property: "og:title", content: "Get Your Hair Back | RESTORE® Hair Transplants — Philadelphia" },
      { property: "og:description", content: "Top hair restoration team serving Philadelphia. Soft, natural, undetectable results." },
      { property: "og:url", content: "https://restorehair.com/locations/pennsylvania/philadelphia/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/pennsylvania/philadelphia/" }],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <HeroChicago
          eyebrow="RESTORE® | Philadelphia Hair Transplants"
          subheading="RESTORE your confidence with the #1 hair restoration team in Philadelphia"
          extraParagraph="Find out about your hair transplant options in Philadelphia."
        />
        <NorwoodQuiz />
        <WhyChooseChicago />
        <Suspense fallback={null}>
          <div className="hidden md:block"><Results /></div>
          <ValueProps hideEyebrowMobile />
          <NoShaveFuture />
          <NoShaveWhy dougLeft />
          <Reviews />
          <Guarantee />
          <Pricing city="Philadelphia" />
          <VirtualConsult />
          <Surgeons
            eyebrow="RESTORE Philadelphia Hair Transplant Doctors"
            heading={<>A World Renowned <span className="text-foreground">Team</span></>}
          />
          <DoctorsGrid />
          <LocationsMapGeneric
            city="Philadelphia"
            stateName="Pennsylvania"
            addressLine1="325-41 Chestnut Street, Suite 800"
            addressLine2="Philadelphia, PA"
            mapQuery="325-41 Chestnut Street Suite 800 Philadelphia PA"
            img={img__asset.url}
            serviceArea="philadelphia"
          />
          <Faq />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
